// hooks/requests/t2pay/useCreateT2Pay.ts

import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { ActivationFormData } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateT2PayProps = {
  formData: ActivationFormData;
} & RequestsProps;

export type UseCreateT2PayReturn = {
  create: (props: CreateT2PayProps) => Promise<void>;
} & UseLoadingReturn;

const useCreateT2Pay = (): UseCreateT2PayReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } =
    useCreate<ActivationFormData>({
      operation: (formData) => t2payService.create(formData),
    });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateT2Pay;
